import type { InputProps } from '../input';

import { forwardRef } from 'react';

import { Input } from '../input';

export type EmailInputProps = Omit<
  InputProps,
  'type' | 'inputMode' | 'autoCapitalize' | 'autoCorrect'
>;

export const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>(
  ({ autoComplete = 'email', ...restProps }, ref) => {
    return (
      <Input
        ref={ref}
        {...restProps}
        type="email"
        inputMode="email"
        autoComplete={autoComplete}
        autoCapitalize="none"
        autoCorrect="off"
      />
    );
  },
);

EmailInput.displayName = 'EmailInput';
